import { getGridSingleSelectOperators, GridFilterInputMultipleSingleSelect } from '@mui/x-data-grid-pro';

import { LabelValue, SavedReportDataType } from '../@types';
import { DuplicatePartsDataType, PartConditionDropdown, SfhOptions } from '../@types/part.type';

export const getSFHDropDownSelectedLabel = (dropdownValue: string, sfhOptions: Array<SfhOptions>) => {
  return sfhOptions.find((sfhOption: SfhOptions) => sfhOption.value === dropdownValue)?.label;
};

export const getPartConditionSelectedLabel = (dropdownValue: string, conditions: Array<PartConditionDropdown>) => {
  return conditions.find((condition: PartConditionDropdown) => condition.value === dropdownValue)?.label || '';
};

export const getFleetTagDropDownSelectedLabel = (dropdownValue: string | number, fleetTagOptions?: Array<LabelValue>) => {
  return fleetTagOptions?.find((fleetTagOption: LabelValue) => fleetTagOption.value === dropdownValue)?.label;
};

export const getPartConditionLabelsfromValues = (selectedConditions: string [] | string, conditionsList?: PartConditionDropdown[]) => {
  if (typeof selectedConditions === 'string') {
    return conditionsList?.find((condition) => condition.value === selectedConditions)?.label as string;
  } else {
    const partConditions: string[] = [];
    selectedConditions.forEach((selectedCondition) => {
      partConditions.push(conditionsList?.find((condition) => condition.value === selectedCondition)?.label as string);
    });
    return partConditions.join();
  }
};

export const disablePartsMergeButton = (mergePartList: DuplicatePartsDataType[]) => {
  return mergePartList.every((part) => !part.allowMerge);
};

export const getPartListInitialFilterModel = (location: string | null) => {
  if (location) {
    return [
      {
        field: 'nodeName',
        operator: 'equals',
        value: location,
      },
    ];
  } else return [
    {
      field: 'serialised',
      operator: 'is',
      value: 'Serialised',
    },
  ];
};

export const getPartLocationLinkByLocationType = (locationType: string, locationId: string) => {
  switch (locationType) {
  case 'part': 
    return `parts/${locationId}`;
  case 'sibling': 
    return `configure/users/${locationId}`;
  default:
    return `structure/${locationId}`;
  }
};

export const getObfuscationData = (defaultReportData: SavedReportDataType[], reportQueryData?: SavedReportDataType) => {
  if (defaultReportData?.length > 0 && defaultReportData[0]?.reportProperties?.obfuscation?.obfuscate) {
    return JSON.stringify(defaultReportData[0]?.reportProperties?.obfuscation);
  } else if (reportQueryData?.reportProperties?.obfuscation?.obfuscate) {
    return JSON.stringify(reportQueryData?.reportProperties?.obfuscation);
  } else return undefined;
};

export const customFilterOperatorsType1 = () => {
  const defaultOperators = getGridSingleSelectOperators();
  return [
    ...defaultOperators,
    {
      label: 'is empty',
      value: 'isEmpty',
      getApplyFilterFn: () => null
    },
    {
      label: 'is not empty',
      value: 'isNotEmpty',
      getApplyFilterFn: () => null
    },
    {
      label: 'is not any of',
      value: 'isNotAnyOf',
      getApplyFilterFn: () => null,
      InputComponent: GridFilterInputMultipleSingleSelect
    }
  ];
};